import { getAuth, onAuthStateChanged } from "firebase/auth";
import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { signOut } from './components/firebase.js'; // Import Firebase auth
import Footer from './components/footer/Footer';
import Header from './components/header/header.js';
import Login from './components/login';
import MyRecipes from './components/MyRecipes';
import Profile from './components/profile/Profile.js';
import About from './components/recipeViews/About';
import Register from './components/Register';
import SavedRecipes from './components/SavedRecipes';
import BudgetFriendly from './pages/BudgetFriendly';
import CreateRecipe from './pages/CreateRecipe.js';
import EditRecipe from './pages/editRecipe.js';
import FilteredRecipes from './pages/FilteredRecipes';
import Home from './pages/Home';
import MealsOfTheDay from './pages/MealsOfTheDay';
import PublicProfile from './pages/PublicProfile';
import RecipeDetails from './pages/RecipeDetails.js';



function App() {

  const [user, setUser] = React.useState(null); // Track the user's authentication status
  const auth = getAuth();
  const handleSignout=()=>{
    signOut(auth);
    window.location.href = '/login';
  }
  // user 
  React.useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
    });
    }, []);


  return (
    <Router>
      <div className="container_ w-screen">
        {/* Navigation links */}
        <Header />
        {/* Define routes within the Routes element */}
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/search" element={<FilteredRecipes />} />
          <Route path="/budget-friendly" element={<BudgetFriendly />} />
          <Route path="/meals-of-the-day" element={<MealsOfTheDay />} />
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/recipe/:recipeId" element={<RecipeDetails />} />
          <Route path='recipe/create' element={<CreateRecipe />}></Route>
          <Route path="/editRecipe/:recipeId" element={<EditRecipe />} />
          <Route path="/user/profile" element={<Profile />} />
          <Route path="/profile/:userId" element={<PublicProfile />} />
          <Route path="/recipes/myrecipes" element={<MyRecipes />} />
          <Route path="/recipes/savedrecipes" element={<SavedRecipes />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
